module.exports = __webpack_public_path__ + "img/imdb.9635665d.png";